import { State } from 'model/State';

/**
 * True if there is a cart and it's in edit mode, false otherwise.
 */
export default (state: State) =>
  state.cart.payload.ifSuccess((cart) => cart && cart.inEditMode) || false;
